// extracted by mini-css-extract-plugin
export default {"container":"Mo-z","brandName":"No-z","productName":"Oo-z","productNamePdpEnhancements":"Po-z","breakLongProductName":"Qo-z"};